<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <t-input v-model="form.toleranceId" hidden/>

      <t-input v-model="form.typeRelation" label="Tipo de Relação" :options="ToleranceType.list" radio
               required/>


      <t-input-person customer
                      v-if="form.typeRelation === ToleranceType.type.CUSTOMER" v-model="form.customerId" required />


      <t-input v-else-if="form.typeRelation === ToleranceType.type.GROUP_CUSTOMER" v-model="form.customerGroupId"
               label="Grupo de Cliente"
               :options="groupCustomerOptions" required select/>

      <t-input-product v-else-if="form.typeRelation === ToleranceType.type.PRODUCT" v-model="form.productId"
                       required/>

      <t-input v-model="form.name"  :add-error="error.name" label="Tabela de Tolerâncias" required/>


      <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

      <t-input-status v-model="form.status"/>

    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import ToleranceType from "@/model/types/modules/product/ToleranceType";
import http from "@/services/config/http-common";

export default {
  mixins: [pageDefaultMixin, pageFormMixin],
  name: 'ToleranceForm',
  data() {
    return {
      ToleranceType,
      path: "product/tolerance", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "toleranceId",
      form: {
        toleranceId: 0,
        toleranceNumber:0,
        typeRelation:1,
        customerId: 0,
        customerGroupId: 0,
        productId: 0,
        name: "",
        note: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
        customerId: "",
        customerGroupId: "",
        productId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      groupCustomerOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

    },
    async mountedContinued() {

      await http.list(this.path + "/selectRelationList").then((response) => {
        this.groupCustomerOptions = response.groupCustomerOptions
      }).catch(error => this.responseError(error))

    },
    async onSubmit() {

      await this.setSendingDefault()

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm()

    await this.mountedContinued()

  },

}
</script>
